"use client";
import * as React from "react";
const SvgBuildRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.357 1.425A4.912 4.912 0 0 0 2.75.493L5.485 3.22a.746.746 0 0 1 0 1.06L4.287 5.473a.74.74 0 0 1-1.062 0L.489 2.747a4.874 4.874 0 0 0 .942 5.581A4.915 4.915 0 0 0 6.623 9.44l5.999 5.98a1.974 1.974 0 0 0 2.796 0 1.959 1.959 0 0 0 0-2.787L9.449 6.676a4.877 4.877 0 0 0-1.092-5.251Z" }));
export {
  SvgBuildRound as default
};
